import * as AgGrid from "ag-grid-community";

export class ToggleAllRows implements AgGrid.IHeaderComp {
  eGui!: HTMLElement;
  params!: AgGrid.IHeaderParams;
  eCheckbox!: HTMLInputElement;

  init(params: AgGrid.IHeaderParams): void {
    this.params = params;
    this.eGui = document.createElement("div");
    this.eGui.innerHTML = `<input class="ag-input-field-input ag-checkbox-input" type="checkbox" tabindex="-1">`;
    this.eCheckbox = this.eGui.querySelector("input") as HTMLInputElement;
    this.eCheckbox.addEventListener("change", this.selectAllVisibleRows.bind(this));
    this.params.api.addEventListener("paginationChanged", this.updateCheckboxState.bind(this));
  }

  getGui(): HTMLElement {
    return this.eGui;
  }

  private selectAllVisibleRows() {
    this.params.api.getRenderedNodes().forEach((node) => node.setSelected(this.eCheckbox.checked));
  }

  private updateCheckboxState() {
    this.eCheckbox.checked = this.params.api.getRenderedNodes().every((node) => node.isSelected());
  }

  refresh(): boolean {
    return false;
  }

  destroy() {
    this.eCheckbox.removeEventListener("change", this.selectAllVisibleRows);
    this.params.api.removeEventListener("paginationChanged", this.updateCheckboxState);
  }
}
